import { PropsWithChildren } from "react";
import { Box, Link, LinkProps, List, ListItem } from "@mui/material";

interface ISubMenuContainerProps {
    align: "left" | "right";
}
export const SubMenuContainer = ({ align, children }: PropsWithChildren<ISubMenuContainerProps>) => {
    return (
        <Box sx={{ position: "absolute", bottom: 0, [align]: 0 }}>
            <List
                role="menu"
                sx={{
                    backgroundColor: "common.white",
                    position: "absolute",
                    py: 1,
                    [align]: 0,
                    opacity: 0,
                    boxShadow: "0 8px 8px 0 rgba(0,0,0,.09)",
                    pointerEvents: "none",
                    transition: "all 0.2s",
                    borderBottomLeftRadius: "8px",
                    borderBottomRightRadius: "8px",
                    borderBottomColor: "transparent",
                }}
            >
                {children}
            </List>
        </Box>
    );
};

interface ISubMenuLinkProps extends LinkProps {
    href: string;
    isActive: boolean;
}

export const SubMenuLink = ({ isActive, ...linkProps }: ISubMenuLinkProps) => {
    return (
        <ListItem role="none" disablePadding>
            <Link
                className="gtm-nav-menu__link"
                variant="unstyled"
                underline="none"
                role="menuitem"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "48px",
                    px: "24px",
                    fontSize: "md",
                    color: isActive ? "green.500" : undefined,
                    whiteSpace: "nowrap",
                    transition: "all 0.2s",
                    "&:hover": { backgroundColor: "gray.50", color: isActive ? "green.500" : "inherit" },
                    "&:active": { backgroundColor: "gray.100" },
                }}
                {...linkProps}
            />
        </ListItem>
    );
};
